import { render, staticRenderFns } from "./AuthPage.vue?vue&type=template&id=b5029dd0&scoped=true&"
import script from "./AuthPage.vue?vue&type=script&lang=ts&"
export * from "./AuthPage.vue?vue&type=script&lang=ts&"
import style0 from "./AuthPage.vue?vue&type=style&index=0&id=b5029dd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5029dd0",
  null
  
)

export default component.exports